module.exports = __webpack_public_path__ + "media/images/svg-sprite-items/payment/bankcontact-185dbc8637d1dac84e6e9a191f91279c.svg";